import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Header from "../../shared_modules/common/header/Header";
import Footer from "../../shared_modules/common/footer/footer";

import MsgBanner from "./MsgBanner";
import PI1Form from "./PI1Form";
import AcctLegalNotice from "./AcctLegalNotice";
import ProviderTrainingBanner from "./ProviderTrainingBanner";

class BorrowerRegistrationComponentReact extends Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultValues: props.defaultValues,
      fillFormButtonDisabled: false,
    };
  }

  static defaultProps = {
    env: "",
  };

  handleOnClick = (ev) => {
    const currentTime = new Date().getTime(),
      randomSSN = Math.floor(100000000 + Math.random() * 900000000).toString(),
      { userInfo } = this.props;

    const autfillValues = {
      epa: "10100",
      pfn: "frp-approve-ni-approve",
      pln: "Bond",
      afn: "John test",
      aln: "Smith",
      addr1: "595 Market St",
      addr2: "300",
      zip: "94105",
      city: "San Francisco",
      state: "CA",
      phone: "1234567890",
      ssn: randomSSN,
      email: `test.pftest${currentTime}@tlcqa.com`,
      emailConfirmation: `test.pftest${currentTime}@tlcqa.com`,
      password: "Welcome1",
      employmentStatus: "RETIRED",
      jobTitle: "",
      employerName: "",
      dob: "10/22/1980",
      gyii: "100000",
      gyai: "5000",
      mmr: "3000",
      esign: userInfo.userType === "applicant" || !userInfo.userType,
      creditauth: true,
      privpolicy: true,
      isAutoFill: true,
    };

    this.setState({
      defaultValues: autfillValues,
      fillFormButtonDisabled: true,
    });
  };

  renderForm() {
    const {
        env,
        shouldRender: shouldRenderForm,
        siteInfo,
        lockApplicationFeatures,
        trainingUrl,
      } = this.props,
      { defaultValues, fillFormButtonDisabled } = this.state,
      nonProdEnvs = [
        "demo",
        "stage",
        "local",
        "dev",
        "development",
        "sandbox",
        "test",
      ],
      baseWrapClass = "pf-page-content",
      nonProdEnvTest = nonProdEnvs.some((envVal) => envVal === env),
      envClass = nonProdEnvTest ? "env-" + env : "env-prod",
      mainClass = env ? baseWrapClass + " " + envClass : baseWrapClass;

    return (
      <Fragment>
        <Header />
        <main className={mainClass} role="main">
          {nonProdEnvTest && (
            <div id="fill-form-wrap" className="fill-form-wrap dev-only">
              <button
                id="fill-form-button"
                className="fill-form-button"
                onClick={this.handleOnClick}
                disabled={fillFormButtonDisabled}
              >
                Fill Form
              </button>
            </div>
          )}
          <MsgBanner />
          <ProviderTrainingBanner
            lockApplicationFeatures={lockApplicationFeatures}
            trainingUrl={trainingUrl}
          />
          {shouldRenderForm && <PI1Form defaultValues={defaultValues} />}
          {shouldRenderForm && <AcctLegalNotice />}
        </main>
        <Footer cprTxtArray={siteInfo.cprTxtArray} />
      </Fragment>
    );
  }

  render() {
    return this.renderForm();
  }
}

const mapStateToProps = (state) => {
  return {
    env: state.env,
    shouldRender: state.shouldRender,
    defaultValues: state.defaultParams || {},
    userInfo: state.userInfo,
    clientInfo: state.clientInfo,
    siteInfo: state.siteInfo,
    lockApplicationFeatures: state.lockApplicationFeatures,
    trainingUrl: state.trainingUrl,
  };
};

BorrowerRegistrationComponentReact.propTypes = {
  env: PropTypes.string.isRequired,
  shouldRender: PropTypes.bool.isRequired,
  defaultValues: PropTypes.object,
  config: PropTypes.object,
  userInfo: PropTypes.object,
  clientInfo: PropTypes.object,
  siteInfo: PropTypes.object,
  lockApplicationFeatures: PropTypes.bool.isRequired,
  trainingUrl: PropTypes.string,
};

const BorrowerRegistrationComponent = connect(mapStateToProps)(
  BorrowerRegistrationComponentReact
);

export { BorrowerRegistrationComponent };

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');